/**
 * Reverse geocode coordinates to get detailed address information including postal code
 */
export const reverseGeocode = async (
  lat: number,
  lng: number,
  apiKey: string
): Promise<any> => {
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
    );
    const data = await response.json();

    if (data.status === "OK" && data.results && data.results.length > 0) {
      // Return the first (most specific) result
      return data.results[0];
    }
    return null;
  } catch (error) {
    console.error("Reverse geocoding failed:", error);
    return null;
  }
};

/**
 * Extract postal code from geocoding result
 */
export const extractPostalCode = (addressComponents: any[]): string | null => {
  if (!addressComponents) return null;

  const postalComponent = addressComponents.find((component: any) =>
    component.types.includes("postal_code") ||
    component.types.includes("postal_code_prefix")
  );

  return postalComponent?.long_name || null;
};
